/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagSe: {
  name: 'flag_se';
  data: string;
} = {
  name: 'flag_se',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#005293" d="M0 0h32v24H0V0Z"/><path fill="#FECB00" d="M0 9.5h32v5H0v-5ZM10.004 0H15v24h-5l.004-24Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
